import { FC, useCallback } from 'react';
import cn from 'classnames';

import RiskLevelButton from '@components/RiskLevelButton/RiskLevelButton';

import { IRiskLevelModalTabProps } from './RiskLevelModalTab.interface';

import './style.scss';

const RiskLevelModalTab: FC<IRiskLevelModalTabProps> = ({
  className,
  riskLevel,
  isActive,
  onClick,
}) => {
  const handleClick = useCallback(() => onClick(riskLevel.riskLevelId), [onClick, riskLevel]);

  return (
    <div
      className={cn('risk-level-modal-tab', { 'risk-level-modal-tab_active': isActive }, className)}
    >
      <RiskLevelButton
        className="risk-level-modal-tab__button"
        riskLevel={riskLevel}
        onClick={handleClick}
      />
    </div>
  );
};

export default RiskLevelModalTab;
